import { Button } from "@/components/ui/button";
import { Loader2, AlertTriangle } from "lucide-react";
import { fmt, breakdown } from "./shelfShared";

export function ReconcileBanner({ reconciliation, orphanSlots, reconciling, onReconcile }) {
  return (
    <div className="space-y-2 rounded-sm border border-red-200 bg-red-50 p-3" data-testid="reconcile-warning">
      <div className="flex items-center gap-2 text-xs text-red-700">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <div className="flex-1 font-semibold">Shelf assignments don't match Units in Stock. Reconcile removes the excess shown below.</div>
        <Button size="sm" variant="outline" disabled={reconciling} className="h-7 shrink-0 rounded-sm border-red-300 text-red-700 hover:bg-red-100" onClick={onReconcile} data-testid="reconcile-button">
          {reconciling ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Reconcile now"}
        </Button>
      </div>
      {reconciliation.length > 0 && (
        <div className="flex gap-2 overflow-x-auto" data-testid="excess-list">
          {reconciliation.map((v) => (
            <div key={v.key} className="w-[220px] shrink-0 rounded-sm border border-red-200 bg-white p-2.5" data-testid={`excess-${v.key}`}>
              <p className="truncate text-sm font-semibold text-slate-900">{v.name}</p>
              <p className="truncate text-[11px] text-slate-500">{v.sub}</p>
              <p className="mt-1 text-[11px] text-slate-600">On shelves {fmt(v.assigned)} · In stock {fmt(v.stock)}</p>
              <p className="text-xs font-semibold text-red-700">Excess: {breakdown(v.assigned - v.stock, v.upc, v.upp).join(" · ")}</p>
            </div>
          ))}
        </div>
      )}
      {orphanSlots.length > 0 && (
        <div className="flex gap-2 overflow-x-auto" data-testid="orphan-list">
          {orphanSlots.map((s) => (
            <div key={s.loc} className="w-[220px] shrink-0 rounded-sm border border-red-200 bg-white p-2.5" data-testid={`orphan-${s.loc}`}>
              <p className="truncate text-sm font-semibold text-slate-900">{s.name}</p>
              <p className="truncate text-[11px] text-slate-500">Slot {s.loc} · {fmt(s.units)} units</p>
              <p className="text-xs font-semibold text-red-700">References a deleted item</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
